import component from './index';

import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

const getBlock = (children) => ({
  name: children.name,
  className: 'feature16-block',
  md: 8,
  xs: 24,
  children: {
    icon: {
      className: 'feature16-icon',
      children: children.icon,
    },
    textWrapper: {
      className: 'feature16-text',
    },
    title: {
      className: 'feature16-title',
      children: children.title,
    },
    content: {
      className: 'feature16-content',
      children: children.content,
    },
  },
});

const getBlockImg = (data) => ({
  name: data.name,
  className: 'img',
  md: 8,
  xs: 24,
  children: {
    wrapper: {
      className: 'img-content',
    },
    img: {
      children: data.img,
    },
  },
});

export default {
  component,
  templateStr,
  less,
  dataSource: {
    wrapper: {
      className: 'home-page-wrapper feature16-wrapper',
    },
    page: {
      className: 'home-page feature16',
    },
    OverPack: {
      playScale: 0.3,
    },
    bg: {
      className: 'bg',
      children: 'https://imm.86links.com/assets/landing/feature/Feature16-bg.png',
    },
    fixedRight: {
      className: 'fixed-right',
    },
    titleWrapper: {
      className: 'title-wrapper',
      children: [
        {
          name: 'title',
          children: '现代服务业',
          className: 'title-h1',
        },
      ],
    },
    block: {
      className: 'feature16-block-wrapper',
      children: [
        getBlock({
          icon: 'https://imm.86links.com/assets/landing/feature/Feature16-img/icon-1.png',
          title: '总部经济',
          content: '聚集一大批知名总部企业，建成经开孵化园、百悦国际中心等总部经济楼宇（园区）载体，快速构建总部经济生态圈。',
          name: 'block0',
        }),
        getBlock({
          icon: 'https://imm.86links.com/assets/landing/feature/Feature16-img/icon-2.png',
          title: '现代文旅产业',
          content: '整合区域特色文化资源优势，初步形成以梵木创艺区、中国艺库为核心的六大文创产业园区。',
          name: 'block1',
        }),
        getBlock({
          icon: 'https://imm.86links.com/assets/landing/feature/Feature16-img/icon-3.png',
          title: '商贸物流',
          content: '大力发展与高端服务业相关的各类产业，加速形成功能丰富的现代服务与物流业聚集发展体系',
          name: 'block2',
        }),
      ],
    },
    img: {
      className: 'img-wrapper',
      children: [
        getBlockImg(
          {
            name: 'block0',
            img: 'https://imm.86links.com/assets/landing/feature/Feature16-img/bottom-1.png',
          }
        ),
        getBlockImg(
          {
            name: 'block1',
            img: 'https://imm.86links.com/assets/landing/feature/Feature16-img/bottom-2.png',
          }
        ),
        getBlockImg(
          {
            name: 'block2',
            img: 'https://imm.86links.com/assets/landing/feature/Feature16-img/bottom-3.png',
          }
        ),
      ],
    },
  },
};
